import { useTranslation } from 'react-i18next';
import PageLayout from '../components/PageLayout';
import AccountCard from '../components/AccountCard';
import PageHeader from '../components/ui/PageHeader';
import PageBody from '../components/ui/PageBody';
import PageMain from '../components/ui/PageMain';
import MediaPoolContent from '../components/MediaPoolContent';
import ArchivedArticlesContent from '../components/ArchivedArticlesContent';
import TagsContent from '../components/TagsContent';

function AdminToolsPage() {
    const { t } = useTranslation();

    return (
        <PageLayout
            extraSidebarItems={[
                {
                    to: '/admin',
                    label: t('adminHome.sidebarTitle'),
                    icon: 'fa-solid fa-user-shield',
                },
            ]}
        >
            <PageMain>
                <PageHeader
                    eyebrow={
                        <a href="/admin">
                            <i className="fa-solid fa-arrow-left" aria-hidden="true" />
                            {t('adminPanel.backToAdmin')}
                        </a>
                    }
                    title={t('adminTools.title')}
                    titleId="admin-tools-title"
                    description={t('adminTools.description')}
                />

                <PageBody
                    className="account-page"
                    aria-labelledby="admin-tools-title"
                >
                    <div className="account-settings-column admin-settings-column">
                        <AccountCard
                            titleId="admin-tools-media-title"
                            isFirst
                            title={t('adminTools.mediaTitle')}
                            description={t('adminTools.mediaDescription')}
                            icon="fa-solid fa-photo-film"
                        >
                            <MediaPoolContent initialUsage="unused" />
                        </AccountCard>

                        <AccountCard
                            titleId="admin-tools-tags-title"
                            title={t('adminTools.tagsTitle')}
                            description={t('adminTools.tagsDescription')}
                            icon="fa-solid fa-tags"
                        >
                            <TagsContent />
                        </AccountCard>

                        <AccountCard
                            titleId="admin-tools-articles-title"
                            title={t('adminTools.articlesTitle')}
                            description={t('adminTools.articlesDescription')}
                            icon="fa-solid fa-box-archive"
                        >
                            <ArchivedArticlesContent />
                        </AccountCard>
                    </div>
                </PageBody>
            </PageMain>
        </PageLayout>
    );
}

export default AdminToolsPage;
